import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/back-to-school.webp";
import BlinkingText from "../../BlinkingText";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";
const TITLE =
  "Berapa Hari Lagi Tahun Ajaran Baru di Arab Saudi 2026 - Hitung Mundur Sekolah";
const DESCRIPTION = "Berapa hari lagi awal tahun ajaran baru di Arab Saudi 2026, tanggal tahun ajaran baru di Arab Saudi, kapan tahun ajaran baru dimulai di Arab Saudi 2026, berapa hari lagi tahun ajaran baru di Arab Saudi 2026, jadwal tahun ajaran baru 2026 di Arab Saudi, berapa hari lagi masuk sekolah di Arab Saudi, jadwal mulai sekolah di Arab Saudi 2026, kapan tahun ajaran baru di Arab Saudi 2026 dimulai, tahun ajaran baru di Arab Saudi 2026, hitung mundur awal sekolah di Arab Saudi 2026, berapa hari lagi awal sekolah di Arab Saudi 2026, tanggal awal sekolah di Arab Saudi 2026, jadwal awal sekolah 2026 di Arab Saudi, kapan tahun ajaran baru di Arab Saudi 2026, hitung mundur tahun ajaran baru di Arab Saudi 2026.";
const KEYWORDS = "berapa hari lagi tahun ajaran baru di Arab Saudi 2026, awal tahun ajaran baru 2026 di Arab Saudi, kapan tahun ajaran baru di Arab Saudi 2026, tanggal awal tahun ajaran baru 2026 di Arab Saudi, hitung mundur awal tahun ajaran baru 2026 di Arab Saudi, berapa hari lagi masuk sekolah di Arab Saudi 2026, jadwal tahun ajaran baru di Arab Saudi 2026, hitung mundur sekolah di Arab Saudi 2026, berapa hari lagi awal tahun ajaran baru 2026 di Arab Saudi.";
const OG_URL = "https://do-calculate.com/articles-id/schooldaySA/";
function MothersDay() {
  const calculateTimeLeft = (targetDate) => {
    const now = new Date();
    const difference = targetDate - now;
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };
  const initialDate = new Date("2026-06-26T00:00:00");
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(initialDate));
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <FirstAds />
      </div>
      <h1 className="p-3 mb-2 bg-success text-white">
        Berapa Hari Lagi Tahun Ajaran Baru 1447 di Arab Saudi
      </h1>
      <div>
        <BlinkingText text="Berapa hari lagi tahun ajaran baru di Arab Saudi: Diperkirakan tahun ajaran baru 1447 di Arab Saudi jatuh pada hari Minggu tanggal 26-06-2026 Masehi atau 01/01/1447 Hijriah." />
      </div>
      <div className="row">
        <div id="timer" style={{ width: "100%", fontSize: "40px" }}>
          <table
            style={{
              width: "100%",
              textAlign: "center",
              borderCollapse: "collapse",
              border: "1px solid #ccc",
            }}
          >
            <thead>
              <tr>
                <th>Hari</th>
                <th>Jam</th>
                <th>Menit</th>
                <th>Detik</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td id="days">{timeLeft.days}</td>
                <td id="hours">{timeLeft.hours}</td>
                <td id="minutes">{timeLeft.minutes}</td>
                <td id="seconds">{timeLeft.seconds}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <SecondAds />
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <h3 className="p-3 mb-2 bg-success text-white">
            Berapa Hari Lagi Tahun Ajaran Baru di Arab Saudi 2026
          </h3>
          <p>
            Dalam artikel ini, kami menyajikan hitung mundur lengkap menuju tahun
            ajaran baru 2026 di Arab Saudi, agar Anda selalu mengetahui berapa
            hari lagi hari yang istimewa ini tiba. Banyak di antara kita yang
            bertanya berapa hari lagi tahun ajaran baru dimulai, oleh karena itu
            kami hadirkan hitung mundur tahun ajaran baru 2026 agar Anda dapat
            mengetahui berapa hari lagi tahun ajaran baru di Arab Saudi 2026, berapa
            hari tersisa. Lihat hitung mundur tahun ajaran baru 2026 di atas.
          </p>
          <p>
            Berdasarkan situs{" "}
            <a href="/calculator/id/gregorian_to_hijri/">konversi tanggal</a>, tahun
            ajaran baru di Arab Saudi 2026 bertepatan dengan hari Minggu
            24-08-2026 Masehi.
          </p>
          <p>
            Temukan di sini hitung mundur tahun ajaran baru, di mana Anda dapat
            mengetahui berapa hari lagi tahun ajaran baru di Arab Saudi.
          </p>
          <hr />
          <RelatedLinks />
          <hr />
          <h3 className="p-3 mb-2 bg-success text-white">
            Hitung Berapa Hari Lagi Tahun Ajaran Baru 2026
          </h3>
          <p>
            Melalui program hitung mundur tahun ajaran baru 2026 di Arab Saudi, Anda
            dapat mengetahui berapa hari lagi tahun ajaran baru 2026 dalam kalender
            Masehi maupun Hijriah. Anda juga dapat mengetahui berapa hari tersisa menuju
            tahun ajaran baru di Arab Saudi dalam hitungan hari, serta kapan tahun
            ajaran baru di Arab Saudi dimulai.
          </p>
          <h3 className="p-3 mb-2 bg-success text-white">
            Tahun Ajaran Baru di Arab Saudi
          </h3>
          <p>
            Tahun ajaran baru di Arab Saudi adalah acara tahunan yang penting,
            ditunggu-tunggu oleh para siswa dan orang tua. Ini adalah hari di mana
            para siswa memulai perjalanan pendidikan baru yang penuh tantangan dan
            peluang. Persiapan untuk hari ini meliputi menyiapkan tas sekolah,
            membeli buku dan perlengkapan belajar, serta memastikan seragam sekolah
            sudah siap. Tahun ajaran baru di Arab Saudi dimulai pada 31 Agustus 2026,
            dan hari ini menandai awal semester baru yang penuh dengan pembelajaran
            dan pertumbuhan akademis serta pribadi.
          </p>
          <div>
            <br />
            <img
              src={imageUrl}
              alt="Berapa hari lagi tahun ajaran baru di Arab Saudi"
              width="800"
              height="450"
              style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
              loading="lazy"
            />
            <br />
          </div>
        </div>
        <div className="col" style={{ paddingTop: "28px" }}>
          <MainCalculatorsList></MainCalculatorsList>
        </div>
        <br />
      </div>
    </div>
  );
}
export default MothersDay;
